import React, { Fragment } from 'react';
import {
  AUTONOMO,
  EMPREENDEDOR,
  LIDER,
  COLABORADOR,
} from '../constants/categoryConstants';

const Lider = () => {
  return (
    <Fragment>
      <p>
        A capacidade de aglutinar pessoas em torno de si e coordenar grupos de
        trabalho na realização de atividades é a mais visível das qualidades de
        um líder. O profissional que tem este perfil prefere desenvolver
        carreira dentro de uma organização que lhe propicie crescimento e
        reconhecimento de suas habilidades.
      </p>
      <p>
        O líder valoriza a segurança que a organização lhe oferece e fica
        fascinado com o prestígio e o poder que a função lhe proporciona. A
        liderança ultrapassa os limites do espaço de trabalho aparecendo em
        diferentes situações e ambientes onde o indivíduo está inserido.
      </p>
      <p>
        Um fator fundamental para o líder é, por natureza, a organização,
        definindo objetivos e buscando atingir suas aspirações profissionais
        através do empenho e aprimoramento pessoal.
      </p>
      <p>
        Pensar estrategicamente e analisar o mercado com o objetivo de preparar
        a organização frente aos desafios e oportunidades do mercado está entre
        as habilidades de um líder. Esta visão macro incentiva o líder a
        discutir, planejar e promover a capacitação de sua equipe, oferecendo as
        melhores alternativas para os clientes.
      </p>
      <p>
        Com forte poder de argumentação, o líder obtém respeito e admiração de
        seus colegas de trabalho. Para um líder, a responsabilidade é um
        atrativo e uma oportunidade de mostrar a todos a sua capacidade e
        talento.
      </p>
    </Fragment>
  );
};

const Colaborador = () => {
  return (
    <Fragment>
      <p>
        O trabalho contínuo e estável são os principais alicerces do perfil de
        um colaborador que também prefere receber orientação para o exercício de
        suas funções e tarefas que deve executar. Os colaboradores esperam
        reconhecimento pelo trabalho desenvolvido, se esforçando, na verdade,
        para desenvolver uma carreira e alcançar melhores condições de trabalho
        e melhores salários.
      </p>
      <p>
        A idéia de bom relacionamento no ambiente de trabalho está presente no
        horizonte de um colaborador que vê na estrutura e condições que lhe
        oferecem fortes pontos de motivação.
      </p>
      <p>
        Regras claras, espaço delimitado, funções e atividades bem definidas
        fazem dos colaboradores profissionais mais felizes e satisfeitos com a
        função que exercem.
      </p>
      <p>
        Os colaboradores preferem atividades que envolvam menos riscos e
        responsabilidades, mas assumem suas funções de acordo com as regras
        estabelecidas no processo.
      </p>
      <p>
        Os benefícios e incentivos oferecidos pelas empresas pesam muito na
        balança dos colaboradores. Estes fatores merecem destaque na escolha de
        um trabalho porque estão diretamente ligados à satisfação profissional.
        Outro fato que muito interessa ao colaborador está na possibilidade de
        crescimento em decorrência da formação profissional exigida pela
        organização. A delimitação deste horizonte profissional se torna um
        importante estímulo para a construção da carreira.
      </p>
    </Fragment>
  );
};

const Autonomo = () => {
  return (
    <Fragment>
      <p>
        O domínio técnico somado a capacidade de comunicação fornecem as
        ferramentas necessárias para que o profissional autônomo desenvolva sua
        atividade com independência. A opção por trabalhar de forma independente
        faz com que o autônomo crie o seu próprio ambiente de trabalho e defina
        as suas rotinas.
      </p>
      <p>
        Esta postura, no entanto, gera algumas dificuldades quando o autônomo
        precisa coordenar as atividades com outras pessoas ou grupos de
        trabalho, o que leva ao desenvolvimento do trabalho de forma individual.
      </p>
      <p>
        O profissional autônomo sabe que para sobreviver no mercado ele precisa
        estar sempre atualizado e, de uma forma, geral os autônomos estão sempre
        em dia com as informações buscando estas informações em publicações
        técnicas e junto a especialistas da sua área de atuação.
      </p>
      <p>
        No desenvolvimento de suas tarefas, os autônomos apresentam muita
        segurança pelo conhecimento que possuem da atividade. Dão ênfase ao
        momento presente, deixando num segundo plano a formação de uma visão de
        longo prazo e a orientação para resultados.
      </p>
      <p>
        Mas os autônomos têm a vantagem de negociar mais livremente as questões
        de trabalho, como horários e remunerações.
      </p>
      <p>
        Possuindo baixos custos de operação por não terem uma ampla estrutura
        física, os profissionais autônomos são muito competitivos em termos de
        valores e com a crescente demanda por terceirização por parte das
        empresas estes profissionais levam boa vantagem sobre os demais.
        Entretanto, ao trabalharem de forma individual, os autônomos têm como
        limite a sua própria capacidade de execução o que limita seu campo de
        atuação.
      </p>
    </Fragment>
  );
};

const Empreendedor = () => {
  return (
    <Fragment>
      <p>
        Os indivíduos empreendedores organizam recursos e influenciam pessoas
        para atingir seus objetivos e conquistar uma ou mais oportunidades de
        mercado, sempre pautados pela liberdade de decisões. Estas
        características aliadas à criatividade formam a base dos empreendedores,
        pessoas que acreditam em idéias inovadoras.
      </p>
      <p>
        Os empreendedores por serem independentes têm dificuldades em trabalhar
        sob a coordenação de outros, mas isto não lhes tira a capacidade de se
        relacionar bem porque o relacionamento é peça fundamental na geração de
        novos negócios e/ou empreendimentos. Esta aptidão desenvolvida para os
        negócios faz com que se arrisquem mais, demonstrando autoconfiança e
        objetividade na busca dos resultados pretendidos.
      </p>
      <p>
        A organização é fator de sucesso para qualquer empreendimento, por isto
        o empreendedor precisa ter clareza na mobilização de todos os recursos e
        coordená-los de forma lógica e harmoniosa, fazendo com que o resultado
        seja maior do que a simples soma das partes.
      </p>
      <p>
        Estar atento e informado estão entre aptidões natas dos empreendedores.
        Nas mais variadas situações de vida, o empreendedor vê tudo sob sua
        ótica de oportunidade e de como aquela informação pode lhe beneficiar.
      </p>
      <p>
        Finalmente, persistência e motivação é que podem assegurar ao
        empreendedor o desenvolvimento de seu projeto. Para o empreendedor
        sempre há um recomeço. Esta visão de mundo tem a qualidade do otimismo,
        mas só alcança o sucesso, quando o empreendedor transforma o sonho em
        realidade.
      </p>
    </Fragment>
  );
};

const ResultDescription = ({ result }) => {
  let winnerTemp = { category: '', points: 0 };
  result.map((r) => {
    if (r.points > winnerTemp.points) {
      winnerTemp.category = r.category;
      winnerTemp.points = r.points;
    }
    return winnerTemp;
  });

  switch (winnerTemp.category) {
    case EMPREENDEDOR:
      return Empreendedor();
    case AUTONOMO:
      return Autonomo();
    case COLABORADOR:
      return Colaborador();
    case LIDER:
      return Lider();
    default:
      return <Fragment></Fragment>;
  }
};

export default ResultDescription;
